import FilterComponent from './FilterComponent';
import FilterDefinition from './FilterDefinition';
import FilterDefinitionTypes from './FilterDefinitionTypes';
import { filterArrayBasedOnObj } from './utils';
import ComparisonOperators from './ComparisonTypes';

FilterComponent.FilterDefinition = FilterDefinition;
FilterComponent.FilterDefinitionTypes = FilterDefinitionTypes;
FilterComponent.filterFunction = filterArrayBasedOnObj;
FilterComponent.ComparisonOperators = ComparisonOperators;

export default FilterComponent;
